import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from './router';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    profile: {},
    rooftop: {},
    dealerGroup: {},
    vehicle: {},
    baseQueryString: `/v1/search/vehicles?limit=20&token=${process.env.VUE_APP_PUBLISHER_TOKEN}&sort=year%7Cdesc,photos_count%7Cdesc&lists=make,model,body_style,year&`,
    filtersQueryString: '',
    colorScheme: {
      header: '#FFF',
      pre_header: '#FFF',
      background: '#c00',
      forms: '#c00',
      footer: '#999',
      accent: '#a60000',
      hover: '#FFF',
    },
    sharedData: {
      isMultiDealerGroup: null,
      phone: null,
      address: null,
      addressLink: null,
    },
    tabID: 'contact-tab',
    banners: [],
    socialSharing: {},
    filters: {
      makes: [],
      models: [],
      bodyStyles: [],
      transmissions: [
        { value: 1, name: 'Automático' },
        { value: 2, name: 'Manual' },
      ],
      conditions: [
        { value: 1, name: 'Nuevo' },
        { value: 2, name: 'Usado' },
      ],
      photos: [
        { value: 1, name: 'Tiene fotos' },
      ],
      mileages: [
        { value: 30000, name: '30,000 o menos' },
        { value: 40000, name: '40,000 o menos' },
        { value: 50000, name: '50,000 o menos' },
        { value: 60000, name: '60,000 o menos' },
        { value: 70000, name: '70,000 o menos' },
        { value: 80000, name: '80,000 o menos' },
        { value: 90000, name: '90,000 o menos' },
        { value: 100000, name: '100,000 o menos' },
      ],
      years: [
        // { value: 2020, name: '2020' },
        // { value: 2019, name: '2019' },
        // { value: 2018, name: '2018' },
        // { value: 2017, name: '2017' },
        // { value: 2016, name: '2016' },
        // { value: 2015, name: '2015' },
        // { value: 2014, name: '2014' },
      ],
    },
  },
  getters: {
    getProfile: state => state.profile,
    getRooftop: state => state.rooftop,
    getDealerGroup: state => state.dealerGroup,
    getVehicle: state => state.vehicle,
    getFiltersQueryString: state => state.filtersQueryString,
    getColorScheme: state => state.colorScheme,
    getTabID: state => state.tabID,
    getBanners: state => state.banners,
    getSocialSharing: state => state.socialSharing,
    getFilters: state => state.filters,
    getSharedData: state => state.sharedData,
  },
  mutations: {
    setProfile(state, profile) {
      state.profile = profile;
    },
    setRooftop(state, rooftop) {
      state.rooftop = rooftop;
    },
    setDealerGroup(state, dealerGroup) {
      state.dealerGroup = dealerGroup;
    },
    setVehicle(state, vehicle) {
      state.vehicle = vehicle;
    },
    setFiltersQueryString(state, filtersQueryString) {
      state.filtersQueryString = filtersQueryString;
    },
    setColorScheme(state, colorScheme) {
      state.colorScheme = colorScheme;
    },
    setSharedData(state, sharedData) {
      state.sharedData = sharedData;
    },
    setTabID(state, tabID) {
      state.tabID = tabID;
    },
    setBanners(state, banners) {
      state.banners = banners;
    },
    setSocialSharing(state, socialSharing) {
      state.socialSharing = socialSharing;
    },
    setModels(state, models) {
      state.filters.models = models.lists.model;
    },
    setFilters(state, filters) {
      state.filters.years = filters.lists.year;
      state.filters.makes = filters.lists.make;
      state.filters.bodyStyles = filters.lists.body_style;
    },
  },
  actions: {
    async requestProfile(store, username = null) {
      await axios.get(`${process.env.VUE_APP_SELLERS_API_URL}/sellers/${username}`).then((response) => {
        store.commit('setProfile', response.data);
      }).catch((error) => {
        if (error.response && error.response.status === 404) {
          router.push({ path: '/error/not-found/404' });
        }
      });
      return store.state.profile;
    },
    async requestRooftop(store, data = null) {
      const rooftop = await axios.get(`${process.env.VUE_APP_SELLERS_API_URL}/rooftop/${data.rooftopID}`);
      store.commit('setRooftop', rooftop.data);
      return store.state.rooftop;
    },
    async requestDealerGroup(store, data = null) {
      const dealerGroup = await axios.get(`${process.env.VUE_APP_SELLERS_API_URL}/dealergroup/${data.dGroupID}`);
      store.commit('setDealerGroup', dealerGroup.data);
      return store.state.dealerGroup;
    },
    async requestVehicle(store, vehicleSlug) {
      await axios.get(`/v1/search/vehicles?q=(slug:${vehicleSlug})&limit=1&token=${process.env.VUE_APP_PUBLISHER_TOKEN}`).then((response) => {
        if (response.data.data[0]) {
          store.commit('setVehicle', response.data.data[0]);
        } else {
          router.push({ path: '/error/not-found/404' });
        }
      });
      return store.state.vehicle;
    },
    async requestVehicles(store, payload) {
      let bQueryString = `${store.state.baseQueryString}&page=${payload.selectedPage}`;
      let queryString = '&q=(';
      if (store.state.profile.rooftops) {
        store.state.profile.rooftops.forEach((element, index) => {
          queryString += index <= 0 ? `rooftop.id:${element.id}` : `|${element.id}`;
        });
      }
      if (payload.selectedFilters.priceRange) {
        const from = payload.selectedFilters.priceRange[0];
        const to = payload.selectedFilters.priceRange[1];
        queryString += `,selling_price.price.value>${from},selling_price.price.value<${to}`;
      }
      if (payload.selectedFilters.transmissions) {
        payload.selectedFilters.transmissions.forEach((element, index) => {
          queryString += index <= 0 ? `,transmission:${element.value}` : `|${element.value}`;
        });
      }
      if (payload.selectedFilters.makes) {
        payload.selectedFilters.makes.forEach((element, index) => {
          queryString += index <= 0 ? `,make:${element}` : `|${element}`;
        });
      }
      if (payload.selectedFilters.models) {
        payload.selectedFilters.models.forEach((element, index) => {
          queryString += index <= 0 ? `,model:${element}` : `|${element}`;
        });
      }
      if (payload.selectedFilters.bodyStyles) {
        payload.selectedFilters.bodyStyles.forEach((element, index) => {
          queryString += index <= 0 ? `,body_style:${element}` : `|${element}`;
        });
      }
      if (payload.selectedFilters.conditions) {
        payload.selectedFilters.conditions.forEach((element, index) => {
          queryString += index <= 0 ? `,condition:${element.value}` : `|${element.value}`;
        });
      }
      if (payload.selectedFilters.years) {
        payload.selectedFilters.years.forEach((element, index) => {
          queryString += index <= 0 ? `,year:${element}` : `|${element}`;
        });
      }
      if (payload.selectedFilters.photos) {
        payload.selectedFilters.photos.forEach((element, index) => {
          queryString += index <= 0 ? ',photos_count>1' : '';
        });
      }
      if (payload.selectedFilters.mileages && payload.selectedFilters.mileages.value) {
        queryString += `,mileage>0,mileage<${payload.selectedFilters.mileages.value}`;
      }
      if (queryString !== '&q=(') {
        bQueryString += `${queryString})`;
        store.commit('setFiltersQueryString', bQueryString);
      }
      bQueryString = bQueryString.replace('&q=(', '');
      const vehicles = await axios.get(store.state.filtersQueryString || bQueryString);
      return vehicles;
    },
  },
});
